import { SyntheticEvent } from 'react';
import { CompleteQuery } from 'modules/queryBuilder/types';
import { useSubmitForPreview } from './useSubmitForPreview';
import { useSubmitForApply } from './useSubmitForApply';
import { SubmitType } from '../types';

export const useOnSubmit = () => {
  const submitForPreview = useSubmitForPreview();
  const submitForApply = useSubmitForApply();

  return (searchQuery: CompleteQuery, event?: SyntheticEvent<HTMLFormElement, SubmitEvent>) => {
    const submitId = event?.nativeEvent.submitter?.id;
    switch (submitId) {
      case SubmitType.preview:
        submitForPreview(searchQuery);
        break;
      case SubmitType.apply:
        submitForApply(searchQuery);
        break;
      default:
        return;
    }
  };
};
